<div class="card">
  <h3 class="card__title card__title--left">Patching by Device</h3>
  <div class="legend legend--left">
    <span><i style="background: var(--green)"></i>Installed</span>
    <span><i style="background: var(--slate)"></i>Missing</span>
  </div>

  @if (devices.length === 0) {
    <div class="empty-state">
      <mat-icon>info_outline</mat-icon>
      <span>No Device Data</span>
    </div>
  } @else {
    <div class="dev-scroll">
      <div class="hbars">
        <div class="hbar" *ngFor="let d of devices" [class.is-active]="activeDevice === d.name">
          <div class="hbar__lbl" [title]="d.name">{{ d.name }}</div>
          <div class="hbar__track" [matTooltip]="tooltip(d)" matTooltipPosition="above" (click)="select(d.name)">
            <div class="hbar__fill" [style.width.%]="d.pct"></div>
            <div class="hbar__miss" *ngIf="missPct(d.pct) > 0" [style.width.%]="missPct(d.pct)"></div>
          </div>
        </div>
      </div>
      <div class="axis">
        <span></span>
        <div class="axis__ticks"><span>0%</span><span>50%</span><span>100%</span></div>
      </div>
    </div>
  }
</div>
